import { Box, TableCell, TableHead, TableRow } from "@material-ui/core";
import React, { useContext, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import CheckIcon from "@material-ui/icons/Check";

import { GeneralTitlePage } from "../../../../../../components/AddGeneralPlan/style";
import { CardNumberText } from "../../../../../../components/AdminCard/style";
import {
  CustomDialog,
  CustomDialogTitle,
  CustomDialogContent,
  CustomDialogTitleWrapper,
  ApplicationDates,
  SubmitButton,
  PrevBtn,
} from "../../../../../../components/Forms/ConfirmVerificationModal/style";
import TopStatisticsBar from "../../../../../../components/TopStatisticsBar";
import Breadcrumb from "../../../../../Common/PageElements/Breadcrumb";
import { ContentWrapper } from "../../../../Administration/Staff/style";
import { CardLabel } from "../../../../PlanDetails/style";
import ApprovalModal from "./ApprovalModal";
import LoadingButton from "../../../../../../components/LoadingButton/LoadingButton";
import EvaluatedVendorsTable from "../../../../../../components/EvaluatedVendorsTable/EvaluatedVendorsTable";
import { queryCache, useMutation, useQuery } from "react-query";
import receiptOfBiddersResponseApi from "../../../../../../redux/api/receiptOfBiddersResponseApi";
import ToastContext from "../../../../../../util/toastContext";
import procurementAPI from "../../../../../../redux/api/procurementAPI";
import AccessControl from "../../../../../../components/AccessControl";
import { Roles } from "../../../../../../components/AccessControl/UserRoles";
import { useRoles } from "../../../../../../hooks/useUserDetails";
import { ProcurementMethodAccessControl } from "../../../../../../shared";
import { useProcurementMethod } from "../../../../../../hooks/queries/useProcurement";
import { Procurement_Method } from "../../../../../../util/constants";
import { StyledTable, TableWrapper, StatusBox } from "../../BIllOfQuantityAppraval/style";
import { format } from "date-fns";
import { RejectButton } from "../../ReceiptOfResponse/VendorsTable/style";

const baseVendorObject = {
  data: {
    responseSummary: {
      total: 0,
      pending: 0,
      evaluated: 0,
    },
    evaluatedVendors: [],
  },
  pagination: {
    totalEntries: 0,
  },
};

const EvaluatedVendors = () => {
  const { activityId, procurementId } = useParams();
  const [open, setOpen] = React.useState(false);
  const [openEndorsementModal, setOpenEndorsementModal] = React.useState(false);
  const [rejectionModal, setRejectionModal] = React.useState(false);
  const [openForwardModal, setOpenForwardModal] = React.useState(false);
  const { role: userRole } = useRoles();
  const [uploadDocument, setUploadDocument] = React.useState([]);
  const { showAlert } = useContext(ToastContext);

  // eslint-disable-next-line
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 10,
  });

  const { data: evaluationStat } = useQuery({
    queryKey: ["evaluation-stat", { procurementId }],
    queryFn: receiptOfBiddersResponseApi.getEvaluationStat,
  });

  const biddersResponse = useQuery({
    queryKey: [
      "biddersResponse",
      {
        Status: 2,
        PageSize: pagination.pageSize,
        PageNumber: pagination.pageNumber,
        id: procurementId,
      },
    ],
    queryFn: receiptOfBiddersResponseApi.evaluatedBids,
  });

  const { method, isSuccess } = useProcurementMethod({ procurementId });

  const documents = useQuery({
    queryKey: [
      "approvalMemo",
      {
        activityId,
      },
    ],
    queryFn: receiptOfBiddersResponseApi.getApprovalDocument,
  });

  const activityDetails = useQuery({
    queryKey: [
      "activityDetails",
      {
        activityId,
      },
    ],
    queryFn: procurementAPI.getActivityById,
  });

  const vendorEndorsementQuery = useQuery({
    queryKey: [
      "vendorEndorsement",
      {
        procurementId,
      },
    ],
    queryFn: procurementAPI.getVendorEndorsements,
  });

  const [endorseVendor, endorseVendorQuery] = useMutation(
    method === Procurement_Method.REQ_QUOTATION ? procurementAPI.RFQendorseVendor : procurementAPI.endorseVendor,
    {
      onSuccess: () => {
        showAlert({
          message: `Recommended vendor was ${openEndorsementModal ? "endorsed" : "forwarded"} successfully`,
          severity: "success",
        });
        setOpenEndorsementModal(false);
        setOpenForwardModal(false);
        vendorEndorsementQuery.refetch();
      },
      onError: (e) => {
        showAlert({
          message: e.message,
          severity: "error",
        });
      },
    }
  );

  const [sendForRecommendation, sendForRecommendationQuery] = useMutation(receiptOfBiddersResponseApi.sendForRecommendation, {
    onError: (e) => {
      showAlert({
        message: e.message,
        severity: "error",
      });
    },
  });

  const [rejectVendor, rejectVendorQuery] = useMutation(receiptOfBiddersResponseApi.rejectRecommendedVendor, {
    onError: (e) => {
      showAlert({
        message: e.message,
        severity: "error",
      });
    },
    onSuccess: () => {
      showAlert({
        message: `Recommended vendor was rejected successfully`,
        severity: "success",
      });
      setRejectionModal(false);
      vendorEndorsementQuery.refetch();
    },
  });

  const {
    data: { evaluatedVendors },
    pagination: apiPagination,
  } = Object.assign(baseVendorObject, biddersResponse.data);

  const updatePagination = (key) => (value) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      [key]: value,
    }));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleEndorseVendor = () => {
    endorseVendor({
      procurementId: method === Procurement_Method.REQ_QUOTATION ? activityId : procurementId,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderLeftContent = () => (
    <Box>
      <CardLabel>Total Bidders</CardLabel>
      <CardNumberText>{evaluationStat?.financial?.total}</CardNumberText>
    </Box>
  );

  const renderCenterContent = () => {
    const { procurementPlanActivityStatus } = activityDetails.data || {};

    const isAwaiting = procurementPlanActivityStatus === "Awaiting";
    const isApproved = procurementPlanActivityStatus === "Approved";

    const ApprovalStages = [
      {
        text: "Endorse Recomended Vendor",
        onClick: () => setOpenEndorsementModal(true),
        allowedRoles: [Roles.PERMANENT_SECRETARY, Roles.ACCOUNTING_OFFICER],
        hasEndorse: !!checkEndorsementStatus(vendorEndorsementQuery?.data, userRole, "endorsed")?.role,
      },
      {
        text: "Endorse Recomended Vendor",
        onClick: () => setOpenEndorsementModal(true),
        allowedRoles: [Roles.COMMISSIONER, Roles.SUPERVISING_OFFICER],
        isAwaitingTurn: !checkEndorsementStatus(
          vendorEndorsementQuery?.data,
          [Roles.PERMANENT_SECRETARY, Roles.ACCOUNTING_OFFICER],
          "endorsed"
        )?.role,
        isReadyTurn: !!checkEndorsementStatus(
          vendorEndorsementQuery?.data,
          [Roles.PERMANENT_SECRETARY, Roles.ACCOUNTING_OFFICER],
          "endorsed"
        )?.role,
        hasEndorse: !!checkEndorsementStatus(vendorEndorsementQuery?.data, userRole, "endorsed")?.role,
      },
      {
        text: "Endorse Recomended Vendor",
        onClick: () => setOpenEndorsementModal(true),
        allowedRoles: [Roles.KWPPA],
        isAwaitingTurn: !checkEndorsementStatus(vendorEndorsementQuery?.data, Roles.COMMISSIONER, "endorsed")?.role,
        isReadyTurn: !!checkEndorsementStatus(vendorEndorsementQuery?.data, Roles.COMMISSIONER, "endorsed")?.role,
        hasEndorse: !!checkEndorsementStatus(vendorEndorsementQuery?.data, userRole, "endorsed")?.role,
      },
      {
        text: "Forward Recomended Vendor",
        onClick: () => setOpenForwardModal(true),
        allowedRoles: [Roles.COMMISSIONER],
        action: "forwarded",
        isAwaitingTurn: !checkEndorsementStatus(vendorEndorsementQuery?.data, Roles.KWPPA, "endorsed")?.role,
        isReadyTurn: !!checkEndorsementStatus(vendorEndorsementQuery?.data, Roles.KWPPA, "endorsed")?.role,
        hasEndorse: !!checkEndorsementStatus(vendorEndorsementQuery?.data, userRole, "forwarded")?.role,
      },
    ];

    const RFQApprovalStages = [
      {
        text: "Endorse Recomended Vendor",
        onClick: () => setOpenEndorsementModal(true),
        // Two variations of accounting Officer role exists because for some reason, some users were given roles "Accounting Officer" and others "Accounting Officers"
        allowedRoles: [Roles.ACCOUNTING_OFFICER],
        isReadyTurn: !checkEndorsementStatus(vendorEndorsementQuery?.data, [Roles.SUPERVISING_OFFICER], "endorsed")?.role,
        hasEndorse: !!checkEndorsementStatus(vendorEndorsementQuery?.data, userRole, "endorsed")?.role,
      },
      {
        text: "Endorse Recomended Vendor",
        onClick: () => setOpenEndorsementModal(true),
        allowedRoles: [Roles.SUPERVISING_OFFICER],
        isReadyTurn: !checkEndorsementStatus(vendorEndorsementQuery?.data, [Roles.GOVERNOR], "endorsed")?.role,
        hasEndorse: !!checkEndorsementStatus(vendorEndorsementQuery?.data, userRole, "endorsed")?.role,
      },
      {
        text: "Endorse Recomended Vendor",
        onClick: () => setOpenEndorsementModal(true),
        allowedRoles: [Roles.GOVERNOR],
        hasEndorse: !!checkEndorsementStatus(vendorEndorsementQuery?.data, userRole, "endorsed")?.role,
      },
    ];

    return (
      <>
        <Box>
          <CardLabel style={{ color: "#FF8D26" }}>Pending Review</CardLabel>
          <CardNumberText>{evaluationStat?.financial.totalPending}</CardNumberText>
        </Box>
        <Box marginLeft="55px">
          <CardLabel style={{ color: "#219653" }}>Evaluated</CardLabel>
          <CardNumberText>{evaluationStat?.financial.totalEvaluated}</CardNumberText>
        </Box>

        <AccessControl allowedRoles={[Roles.MINISTERIAL_TENDER_BOARD]}>
          {!isApproved && (
            <Box ml="auto">
              <LoadingButton
                onClick={handleClickOpen}
                endIcon={isAwaiting ? null : <CheckIcon width="10px" />}
                color="#2AA96D"
                disabled={isAwaiting || evaluationStat?.financial?.total !== evaluationStat?.financial.totalEvaluated}
              >
                {isAwaiting ? "Waiting for approval" : "Submit Recommendation For Approval"}
              </LoadingButton>
            </Box>
          )}
        </AccessControl>
        {isAwaiting && (
          <Box display="flex" style={{ gap: "10px", minWidth: "70%", justifyContent: "flex-end" }}>
            <ProcurementMethodAccessControl
              method={method}
              allowedMethod={Object.values(Procurement_Method).filter((value) => value !== Procurement_Method.REQ_QUOTATION)}
              isSuccess={isSuccess}
            >
              <Box display="flex" style={{ gap: "10px" }}>
                {ApprovalStages.map((el) => (
                  <AccessControl allowedRoles={el.allowedRoles}>
                    <LoadingButton onClick={el.onClick} color="#2AA96D" disabled={el.hasEndorse || el.isAwaitingTurn}>
                      {el.hasEndorse
                        ? el.action === "forwarded"
                          ? "Vendor Forwarded"
                          : "Vendor Endorsed"
                        : el.isAwaitingTurn
                        ? el.action === "forward"
                          ? "Awaiting to forward vendor"
                          : "Awaiting turn"
                        : el.text}
                    </LoadingButton>
                  </AccessControl>
                ))}
              </Box>
            </ProcurementMethodAccessControl>

            <ProcurementMethodAccessControl
              method={method}
              allowedMethod={[Procurement_Method.REQ_QUOTATION]}
              isSuccess={isSuccess}
            >
              <Box ml="auto">
                {RFQApprovalStages.map((el) => (
                  <AccessControl allowedRoles={el.allowedRoles}>
                    <LoadingButton onClick={el.onClick} color="#2AA96D" disabled={el.hasEndorse || el.isAwaitingTurn}>
                      {el.hasEndorse
                        ? el.action === "forwarded"
                          ? "Vendor Forwarded"
                          : "Vendor Endorsed"
                        : el.isAwaitingTurn
                        ? el.action === "forward"
                          ? "Awaiting to forward vendor"
                          : "Awaiting turn to endorse vendor"
                        : el.text}
                    </LoadingButton>
                  </AccessControl>
                ))}
              </Box>
            </ProcurementMethodAccessControl>
            <ProcurementMethodAccessControl
              method={method}
              allowedMethod={[
                Procurement_Method.INTERNATIONAL_COMPETITIVE_BIDDING,
                Procurement_Method.NATIONAL_COMPETITIVE_BIDDING,
                Procurement_Method.RESTRICTED_TENDERING_METHOD,
              ]}
              isSuccess={isSuccess}
            >
              <RejectButton onClick={() => setRejectionModal(true)} disabled={rejectVendorQuery.isLoading}>
                Reject Vendor
              </RejectButton>
            </ProcurementMethodAccessControl>
          </Box>
        )}
      </>
    );
  };

  const recommend = async () => {
    try {
      await sendForRecommendation({
        File: uploadDocument[0],
        activityId,
      });

      handleClose();
      queryCache.invalidateQueries("biddersResponse");

      showAlert({
        message: "Succcessfully uploaded recommend document",
        severity: "success",
        durationInMs: 3000,
      });
    } catch (e) {
      showAlert({
        message: e.message,
        severity: "error",
        durationInMs: 3000,
      });
    }
  };

  const topBarStatus = useMemo(() => {
    const { procurementPlanActivityStatus } = activityDetails.data || {};

    if (procurementPlanActivityStatus === "Awaiting") {
      return "pending";
    } else if (procurementPlanActivityStatus === "Approved") {
      return "approved";
    } else {
      return null;
    }
  }, [activityDetails.data]);

  return (
    <ContentWrapper>
      <Box mt={3}>
        <GeneralTitlePage>Evaluated Vendors</GeneralTitlePage>
        <Breadcrumb
          values={[
            {
              url: "/dashboard/overview",
              title: "Home",
            },
            {
              url: `/admin/procurement/plans`,
              title: "Plans",
            },
            {
              url: `/admin/procurement/plan-details/${procurementId}`,
              title: "Plan Details",
            },
            {
              url: `/admin/procurement/activity/receiptofbiddersresponse/${activityId}/${procurementId}`,
              title: "Receipt of bidders response",
            },
            {
              url: `#`,
              title: "Evaluated Vendors",
            },
          ]}
        />
      </Box>

      <Box marginTop="43px">
        <TopStatisticsBar
          leftContent={renderLeftContent()}
          hasApproveStatus={documents.data?.length > 0}
          centerContent={renderCenterContent()}
          isLoading={documents.isLoading}
          status={topBarStatus}
        />
      </Box>

      <ProcurementMethodAccessControl
        isSuccess={isSuccess}
        noLoader
        method={method}
        allowedMethod={[
          Procurement_Method.DIRECT_LABOUR,
          Procurement_Method.DIRECT_PROCUREMENT,
          Procurement_Method.REQ_QUOTATION,
        ]}
      >
        <EvaluatedVendorsTable
          isLoading={biddersResponse.isLoading}
          vendors={evaluatedVendors}
          pageNumber={pagination.pageNumber}
          pageSize={pagination.pageSize}
          setPageNumber={updatePagination("pageNumber")}
          setPageSize={updatePagination("pageSize")}
          totalPages={apiPagination.totalEntries}
        />
      </ProcurementMethodAccessControl>

      <ProcurementMethodAccessControl
        isSuccess={isSuccess}
        noLoader
        method={method}
        allowedMethod={[
          Procurement_Method.INTERNATIONAL_COMPETITIVE_BIDDING,
          Procurement_Method.NATIONAL_COMPETITIVE_BIDDING,
          Procurement_Method.RESTRICTED_TENDERING_METHOD,
        ]}
      >
        <TableWrapper>
          <StyledTable>
            <TableHead>
              <TableRow>
                <TableCell>Role</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <>
              {vendorEndorsementQuery?.data?.map((field) => (
                <TableRow key={field.role}>
                  <TableCell>{field.role}</TableCell>
                  <TableCell>
                    <StatusBox colorStatus={field.status}>{field.status}</StatusBox>
                  </TableCell>
                  <TableCell>
                    {field.endorseDate ? format(new Date(field.endorseDate), "dd MMM yyyy") : " Not Available"}
                  </TableCell>
                </TableRow>
              ))}
            </>
          </StyledTable>
          <Box style={{ width: "100%", padding: "40px" }} />
        </TableWrapper>
      </ProcurementMethodAccessControl>

      <ApprovalModal
        btnText="Submit Recommendation For Approval"
        filesNames={uploadDocument}
        setFilesNames={setUploadDocument}
        handleClose={handleClose}
        open={open}
        onClickButton={recommend}
        isLoading={sendForRecommendationQuery.isLoading}
        cardTitle="Send For Approval"
        docInfo="Upload Evaluation document here"
      />
      <CustomDialog scroll="body" onClose={() => setOpenEndorsementModal(false)} open={openEndorsementModal}>
        <CustomDialogTitleWrapper>
          <CustomDialogTitle disableTypography>Endorse Recommended Vendor</CustomDialogTitle>
        </CustomDialogTitleWrapper>
        <CustomDialogContent>
          <ApplicationDates>Are you sure you want to endorse this recommended vendor?</ApplicationDates>
        </CustomDialogContent>
        <Grid container justify="space-between">
          <div />
          <div>
            <PrevBtn onClick={() => setOpenEndorsementModal(false)}>Cancel</PrevBtn>
            <SubmitButton onClick={handleEndorseVendor} disabled={endorseVendorQuery.isLoading}>
              {endorseVendorQuery.isLoading ? "Endorsing Vendor..." : "Endorse Vendor"}
            </SubmitButton>
          </div>
        </Grid>
      </CustomDialog>
      <CustomDialog scroll="body" onClose={() => setRejectionModal(false)} open={rejectionModal}>
        <CustomDialogTitleWrapper>
          <CustomDialogTitle disableTypography>Reject Recommended Vendor</CustomDialogTitle>
        </CustomDialogTitleWrapper>
        <CustomDialogContent>
          <ApplicationDates>Are you sure you want to reject this recommended vendor?</ApplicationDates>
        </CustomDialogContent>
        <Grid container justify="space-between">
          <div />
          <div>
            <PrevBtn onClick={() => setRejectionModal(false)}>Cancel</PrevBtn>
            <RejectButton onClick={() => rejectVendor(procurementId)} disabled={rejectVendorQuery.isLoading}>
              {rejectVendorQuery.isLoading ? "Rejecting Vendor..." : "Reject Vendor"}
            </RejectButton>
          </div>
        </Grid>
      </CustomDialog>
      <CustomDialog scroll="body" onClose={() => setOpenForwardModal(false)} open={openForwardModal}>
        <CustomDialogTitleWrapper>
          <CustomDialogTitle disableTypography>Forward Recommended Vendor</CustomDialogTitle>
        </CustomDialogTitleWrapper>
        <CustomDialogContent>
          <ApplicationDates>Are you sure you want to forward this recommended vendor?</ApplicationDates>
        </CustomDialogContent>
        <Grid container justify="space-between">
          <div />
          <div>
            <PrevBtn onClick={() => setOpenForwardModal(false)}>Cancel</PrevBtn>
            <SubmitButton onClick={handleEndorseVendor} disabled={endorseVendorQuery.isLoading}>
              {endorseVendorQuery.isLoading ? "Forwarding Vendor..." : "Forward Vendor"}
            </SubmitButton>
          </div>
        </Grid>
      </CustomDialog>
    </ContentWrapper>
  );
};

function checkEndorsementStatus(endorsements, role, action) {
  const endorsedStage = endorsements?.filter((el) => {
    const endorsementRole = el.role?.split(" ").join("_").toLowerCase().split("/");

    const isRole = Array.isArray(role) ? role.some((r) => endorsementRole.includes(r)) : endorsementRole.includes(role);

    const stage = isRole && el.action?.toLowerCase() === action;
    return stage;
  })[0];

  return endorsedStage;
}

export default EvaluatedVendors;
